import { Location } from '@angular/common';
import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { BreadcrumbsService } from '@bci-web-core/core';
import { combineLatest } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { Constants } from 'src/app/shared';
import * as ObjectUtils from 'util';
import { Forecast, SiteModel, SolarConfigModel } from '../../models/index';
import {
  CommonService,
  PlantServiceService,
  SiteService,
  UtilitiesService
} from '../../services/index';
import { SiteTabEnum } from '../../shared/index';
export let browserRefresh = false;
@Component({
  selector: 'app-site-dashboard',
  templateUrl: './site-dashboard.component.html',
  styleUrls: ['./site-dashboard.component.scss']
})
export class SiteDashboardComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @ViewChild('tabs') tabs: MatTabGroup;
  siteId: string;
  siteName: string;
  model: SiteModel;
  forecast: Forecast;
  latestModuleTemp: string;
  solarConfig: SolarConfigModel;
  activeTabIndex = 0;
  windSpeed = 'NA';
  lineManagementTabs = [];
  PER_SolarDashboard = true;
  PER_EnergyDashboard = true;
  PER_OverView = true;
  PER_Utilities = true;
  PER_MachineMonitoring = true;
  PER_KPIBenchMarking = true;
  activeAlerts = 0;
  displayTempPanel = true;
  constructor(
    private breadcrumbsService: BreadcrumbsService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private plantService: PlantServiceService,
    private commonService: CommonService,
    private utilitiesService: UtilitiesService,
    private siteService: SiteService,
    private location: Location,
    private authService: AuthService
  ) {
    this.siteId = this.activeRoute.snapshot.queryParams['siteId'];
    this.siteName = this.activeRoute.snapshot.queryParams['siteName'];
    if (ObjectUtils.isNullOrUndefined(this.siteId)) {
      this.siteId = localStorage.getItem('siteId');
    }
    if (this.siteId === 'TATAThen625564' || this.siteId === 'CUMMDarlDL1468') {
      this.displayTempPanel = false;
    }
    if (ObjectUtils.isNullOrUndefined(this.siteName)) {
      this.siteName = localStorage.getItem('siteName');
    }
    this.latestModuleTemp = 'NA';
    this.model = new SiteModel();
    this.forecast = new Forecast();
    this.solarConfig = new SolarConfigModel();
    this.PER_OverView = authService.doAuthorization([
      Constants.ACTIVITY.DASHBOARD_OVERVIEW
    ]);
    this.PER_EnergyDashboard = authService.doAuthorization([
      Constants.ACTIVITY.ENERGY_DASHBOARD
    ]);
    this.PER_SolarDashboard = authService.doAuthorization([
      Constants.ACTIVITY.SOLAR_DASHBOARD_VIEW
    ]);
    this.PER_Utilities = authService.doAuthorization([
      Constants.ACTIVITY.UTILITIES
    ]);
    this.PER_MachineMonitoring = authService.doAuthorization([
      Constants.ACTIVITY.MACHINEMONITORING
    ]);
    this.PER_KPIBenchMarking = authService.doAuthorization([
      Constants.ACTIVITY.KPIBENCHMARKING
    ]);

    this.lineManagementTabs = [
      {
        id: 'overview-tab',
        label: 'Overview',
        path: 'over-view',
        iconClass: 'bosch-ic-watch-on mat-icon Bosch-Ic',
        disable: !this.PER_OverView
      },
      {
        id: 'energy-tab',
        label: 'Energy',
        path: 'energy-dashboard/energy',
        iconClass: 'bosch-ic-flash mat-icon Bosch-Ic',
        disable: !this.PER_EnergyDashboard
      }
      /* {
         id:'utilities-tab',
         label: 'Utilities',
         path: 'utilities',
         iconClass: 'bosch-ic-lightbulb-attention mat-icon Bosch-Ic',
         disable: !this.PER_Utilities
       },*/
      // {
      //   id: 'solar-tab',
      //   label: 'Solar',
      //   path: 'solar-dashboard',
      //   iconClass: 'bosch-ic-dealer-details mat-icon Bosch-Ic',
      //   disable: !this.PER_SolarDashboard
      // },
      /*{
        id:'machine-monitoring-tab',
        label: 'Machine Monitoring',
        path: 'machine-monitoring',
        iconClass: 'bosch-ic-desktop-graph mat-icon Bosch-Ic',
        disable: !this.PER_MachineMonitoring
      },
      {
        id:'kpi-benchmarking-tab',
        label: 'KPI Benchmarking',
        path: 'kpi-benchmarking',
        iconClass: 'bosch-ic-chart-line mat-icon Bosch-Ic',
        disable: !this.PER_KPIBenchMarking
      }*/
    ];
  }

  ngOnInit() {
    localStorage.setItem('siteId', this.siteId);
    localStorage.setItem('siteName', this.siteName);
    // Combine them both into a single observable
    const urlParams = combineLatest(
      this.activeRoute.params,
      this.activeRoute.queryParams,
      (params, queryParams) => ({ ...params, ...queryParams })
    );
    urlParams.subscribe((routeParams) => {
      if (ObjectUtils.isNullOrUndefined(routeParams.activedTab) === false) {
        this.activeTabIndex = parseInt(routeParams.activedTab);
      }
    });
    this.plantService.getSiteDetail(this.siteId).subscribe((data) => {
      if (data !== null) {
        this.plantService.sendSiteDetailSubject(data);
        this.model = <SiteModel>data;
        // this.commonService.getWeatheritemsbyCity(this.model.city)
        //   .subscribe(res => {
        //     this.forecast = <Forecast>res;
        //   });
      }
    });
    this.plantService.getLatestModuleTemp(this.siteId).subscribe((res) => {
      if (res !== null) {
        this.latestModuleTemp = this.commonService.isNullOrUndefined(
          res.moduleTempValue
        )
          ? 'NA'
          : res.moduleTempValue;
      }
    });
    this.plantService
      .getSolarConfigurationInfo(this.siteId)
      .subscribe((res) => {
        if (res !== null) {
          this.solarConfig = <SolarConfigModel>res;
          this.solarConfig.siteId = this.siteId;
          this.plantService.sendSolarConfigSubject(this.solarConfig);
        }
      });
    // this.plantService.getWindSpeed(this.siteId)
    //   .subscribe(data => {
    //     this.windSpeed = data.windSpeed;
    //   });
    this.siteService.getActiveAlertsOfSite(this.siteId).subscribe((data) => {
      if (data > 0) {
        this.activeAlerts = data;
      }
    });

    // Update selected tab base on URL - In case user use Back - Next button on browser.
    this.location.subscribe(() => {
      let currentLocation = this.location.path(true);
      if (currentLocation) {
        currentLocation = currentLocation.replace('/site/', '');
        if (currentLocation.indexOf('?') > 0) {
          currentLocation = currentLocation.substr(
            0,
            currentLocation.indexOf('?')
          );
        }
        if (currentLocation.indexOf('/') > 0) {
          currentLocation = currentLocation.substr(
            0,
            currentLocation.indexOf('/')
          );
        }
        // console.log(currentLocation);
        if (currentLocation && currentLocation.length > 0) {
          for (let i = 0; i < this.lineManagementTabs.length; i++) {
            if (this.lineManagementTabs[i].path === currentLocation) {
              this.activeTabIndex = i;
              break;
            }
          }
        }
      }
    });
  }

  navigate($event: MatTabChangeEvent) {
    // const tab = this.lineManagementTabs[$event.index];
    // this.router.navigate(['site/', tab.path], { queryParams: { siteId: this.siteId } });
  }
  tabClick(tab) {
    this.router.navigate([`site/${tab.path}`], {
      queryParams: { siteId: this.siteId }
    });
  }
  ngAfterViewInit() {
    const url = this.commonService.getPlantLogoUrl(this.siteId);
    this.utilitiesService.displayPlantLogo(url);
    switch (this.activeTabIndex) {
      case SiteTabEnum.Energy: {
        this.router.navigate(['site/energy-dashboard', 'energy'], {
          queryParams: { siteId: this.siteId }
        });
        break;
      }
      case SiteTabEnum.SolarDashboard: {
        this.router.navigate(['site/solar-dashboard', 'plant-view'], {
          queryParams: { siteId: this.siteId }
        });
        break;
      }
      default: {
        this.router.navigate(['site', 'over-view'], {
          queryParams: { siteId: this.siteId }
        });
        break;
      }
    }
  }
  ngOnDestroy() {
    this.plantService.unSubscribeSiteDetailSubject();
  }
}
